<div class="connectors-content">
    <div class="connector" id="connector" [attr.data-automation-id]="automationId + '-connector-container'"
        [resBusySpinner]="isConnectorsBusy" message="Loading Connectors ...">
        <res-generic-grid gridName="Connectors" [automationId]="automationId" [columnDefs]="columnDefs"
            [rowSelection]="rowSelection" [requestInfo]="requestInfo" [pagerVisible]="false"
            [responseCallback]="responseCallback" [loadDataFinishedCallback]="loadDataFinishedCallback"
            [onSelectionChanged]="onSelectionChanged" [rowClassRules]="rowDisableRules">
        </res-generic-grid>
    </div>

    <res-resizer [attr.data-automation-id]="automationId + '-resizer-button'" anchor="left"
        resizingElementId="connector" secondElementId="connectorPath" [usePercentages]="true" [initSize]="70"
        [minSize]="20" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>

    <div class="modal-fill connector-path" id="connectorPath"
        [attr.data-automation-id]="automationId + '-path-container'" [resBusySpinner]="isPathsBusy"
        message="Loading Folders ...">
        <div class="header header-cell">
            <span>Folder</span>
        </div>
        <div class="place-holder-area">
            <div [hidden]="selectedConnector || isPathsBusy" class="no-connectors-container">
                <i class="fa fa-arrow-left"></i>Please select a connector
            </div>
        </div>
        <div class="no-connectors-container" [(resScrollablePopover)]="showPopover"
            popoverErrorMessage="No folders found." popoverType="error" popoverPlacement="top" [popoverOffsetTop]="40"
            [isSingleLine]="true" [popoverAutomationId]="automationId  + '-connector-no-folders-error-label'">
        </div>
        <div class="tree-container">
            <res-generic-tree [automationId]="automationId + '-tree'" [loadNodeDataCallback]="loadNodeDataCallback"
                [selectedNodeChangedCallback]="selectedNodeChangedCallback"></res-generic-tree>
        </div>
    </div>
</div>